import Cookies from 'js-cookie';
import actions from './actions';
import api from '../../api/customer';
import axios from 'axios';

const { loginBegin, loginSuccess, loginErr, logoutBegin, logoutSuccess, logoutErr, fetchBegin, fetchSuccess, fetchErr, } = actions;

const login = (email, password) => {
  return async dispatch => {
    try {
      dispatch(loginBegin());
			await api.login({
				email,
				password,
				cb: (userId) => {
          
          console.log("=>" + userId);
          dispatch(loginSuccess(true));

          console.log('timeout ' + userId);
          dispatch(fetchUser());

        },
      });
      
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const fetchUser = () => {
  return async dispatch => {
    try {
      dispatch(fetchBegin());
      await api.get({
        cb: (user) => dispatch(fetchSuccess(user)),
      });
      //
    } catch (err) {
      dispatch(fetchErr(err));
    }
  };
};

const logOut = () => {
	return async (dispatch) => {
		try {
			dispatch(logoutBegin());
      Cookies.remove('logedIn');
      Cookies.remove('user');
      dispatch(logoutSuccess(null));
      location.reload();
		} catch (err) {
			dispatch(logoutErr(err));
		}
	};
};

export { login, logOut, fetchUser };
